module.exports = __webpack_public_path__ + "static/media/coming_soon_desktop.52b11572.webp";